import { render, staticRenderFns } from "./DetailsNotificationPopup.vue?vue&type=template&id=e44ba572"
import script from "./DetailsNotificationPopup.vue?vue&type=script&lang=js"
export * from "./DetailsNotificationPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports